/**
 * The Symagic Server SpendTime entity.
 * @author Tom Verschoore de la Houssaije
 */
import * as moment from 'moment';
/**
 * The Symagic Server SpendTime entity.
 */
var SpendTime = /** @class */ (function () {
    function SpendTime() {
        /**
         * Gets, sets the field that holds the value of the Account_Oid property.
         * @private
         */
        this.accountOid = '';
    }
    Object.defineProperty(SpendTime.prototype, "Start", {
        /**
         * Gets the Start of the time spend.
         * @type {Date}
        * */
        get: function () {
            return this._start;
        },
        /**
         * Sets the Start of the time spend.
         */
        set: function (value) {
            this._start = value;
            this.setDate();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SpendTime.prototype, "Finish", {
        /**
         * Gets the Finish of the time spend.
         * @type {Date}
         */
        get: function () {
            return this._finish;
        },
        /**
         * Sets the Finish of the time spend.
         */
        set: function (value) {
            this._finish = value;
            this.setDate();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SpendTime.prototype, "IsCompleted", {
        /**
         * Gets the IsCompleted of the SpendTime: Boolean wrapper for SpendTime.Completed
         * @type {Boolean}
         */
        get: function () {
            return (this.Completed === 100) ? true : false;
        },
        /**
         * Sets IsCompleted of the SpendTime.
         */
        set: function (value) {
            if (value === true) {
                this.Completed = 100;
            }
            else {
                this.Completed = 0;
            }
        },
        enumerable: true,
        configurable: true
    });
    SpendTime.prototype.setDate = function () {
        if (this.entityAspect.entityState.isAdded() || this.entityAspect.entityState.isDetached()) {
            return;
        }
        if (this.Start > this.Finish) {
            return;
        }
        switch (this.AccountClass) {
            case 'APPOINTMENT':
                this.Effort = moment.duration(moment(this.Finish).diff(moment(this.Start))).toISOString();
                return;
        }
    };
    Object.defineProperty(SpendTime.prototype, "Account_Oid", {
        /**
         * Gets the foreign key of the account on which the spend time is booked.
         * @type {string}
         */
        get: function () {
            return this.accountOid;
        },
        /**
         * Sets the foreign key of the account on which the spend time is booked.
         * @type {string}
         */
        set: function (value) {
            var previousAccountOid = this.accountOid;
            this.accountOid = value;
            if (this.accountOid == null) {
                return;
            }
            if (this.accountOid.indexOf('_') !== -1) {
                // Oid from virtual object e.g. PlanItem
                this.accountOid = this.accountOid.split('_')[0];
            }
            if (this.entityAspect.entityState.isAdded()) {
                var work = this.GetEntityByOid(this.accountOid);
                var previousWork = this.GetEntityByOid(previousAccountOid);
                // Only replace empty names or names that are exactly the same as the previous work entity.
                if (work && (this.Name === '' || (previousWork && this.Name === previousWork['Name']))) {
                    this.Name = work['Name'];
                }
                this.SumFactor = 1; // Default value
                this.IsCompleted = true; // Default value
                if (work) {
                    var resource = work['Resource'];
                    if (resource && this['$currentUser']['HTML5Role'] !== 'EMPLOYEE') {
                        this['Resource'] = resource;
                    }
                    switch (this.AccountClass) {
                        case 'ABSENCE': // Effort gives hours absent when AccountClass is ABSENCE.
                            this.Start = work['Start'];
                            this.Finish = work['Finish'];
                            this.Effort = work['HoursOfLeave'];
                            this.SumFactor = work['SumFactor'];
                            return;
                        case 'ASSIGNMENT':
                            this.Start = work['Start'];
                            this.Finish = work['Finish'];
                            this.Effort = work['Effort'];
                            var unforeseen = (work['Unforeseen'] + '').trim();
                            this.Unforeseen = unforeseen === '' ? 'NO' : unforeseen;
                            this.SumFactor = work['SumFactor'];
                            return;
                        case 'APPOINTMENT':
                        case 'ATTENDANT':
                            this.Start = work['Start'];
                            this.Finish = work['Finish'];
                            this.Effort = moment.duration(moment(this.Finish).diff(moment(this.Start))).toISOString();
                            this.SumFactor = work['SumFactor'];
                            return;
                    }
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SpendTime.prototype, "AccountClass", {
        /**
         * Gets the class of the SpendTime Account.
         * Is useful to get specific detail configurations.
         * @readonly
         * @type {string}
         */
        get: function () {
            if (!this.accountOid || 0 === this.accountOid.length) {
                return 'UNKNOWN';
            }
            if (this.accountOid.indexOf('E1') === 0) {
                return 'TASK';
            }
            if (this.accountOid.indexOf('51') === 0) {
                var entity = this.entityAspect.entityManager.getEntityByKey('Assignment', this.accountOid);
                // Assignments met waarde true voor de property Appointment worden binnen HTML5 als Appointments gezien.
                return entity && entity['Appointment'] ? 'APPOINTMENT' : 'ASSIGNMENT';
            }
            if (this.accountOid.indexOf('93') === 0) {
                // Eerder hielde we rekening met Appointments die geen Absence als reden hadden.
                // Van deze Symagic Server mogelijkheid wordt geen gebruik gemaakt.
                // Appointments behoren nu functioneel altijd een Absence als reden te hebben.
                return 'ABSENCE';
            }
            if (this.accountOid.indexOf('O1') === 0) {
                // Alvast als we er iets mee gaan doen.
                return 'PROJECT';
            }
            if (this.accountOid.indexOf('U3') === 0) {
                // Alvast als we er iets mee gaan doen.
                return 'ATTENDANT';
            }
            return 'UNSUPPORTED';
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Get an existing account entity bij its Oid.
     * @param entityOid The Oid of the entity to get.
     */
    SpendTime.prototype.GetEntityByOid = function (entityOid) {
        if (entityOid.indexOf('51') === 0) {
            return this.entityAspect.entityManager.getEntityByKey('Assignment', entityOid);
        }
        else if (entityOid.indexOf('93') === 0) {
            return this.entityAspect.entityManager.getEntityByKey('Appointment', entityOid);
        }
        else if (entityOid.indexOf('E1') === 0) {
            return this.entityAspect.entityManager.getEntityByKey('Task', entityOid);
        }
        else if (entityOid.indexOf('O1') === 0) {
            return this.entityAspect.entityManager.getEntityByKey('Project', entityOid);
        }
        else if (entityOid.indexOf('U3') === 0) {
            return this.entityAspect.entityManager.getEntityByKey('Attendant', entityOid);
        }
        return null;
    };
    return SpendTime;
}());
export { SpendTime };
